export default __webpack_public_path__ + "static/media/avatar_8_1.2d14eec7.png";